import React, { Component } from 'react'

import { formatCurrency } from '@utilities/numbers'
import styles from './TotalFundingChart.module.scss'

interface IProps {
  // Half one
  repairProvisions: number
  fees: number
  stampDuty: number
  purchasePrice: number

  // Half two
  tenantEquityLoan: number
  standardEquityLoan: number
  firstChargeMortgage: number
}

export default class TotalFundingChart extends Component<IProps> {
  render() {
    let {
      // Half one
      repairProvisions,
      fees,
      stampDuty,
      purchasePrice,

      // Half two
      tenantEquityLoan,
      standardEquityLoan,
      firstChargeMortgage
    } = this.props

    let totalIncludingCosts = purchasePrice + repairProvisions + fees + stampDuty

    return (
      <ul className={styles.total_funding_chart}>
        <li className={styles.chart_half_1}>
          <ul className={styles.chart_half_1_legend}>
            <li>
              <strong>Repair Provisions</strong>
              <br />
              {formatCurrency(repairProvisions, 0)}
            </li>
            <li>
              <strong>Legal, Surveys, Fees</strong>
              <br />
              {formatCurrency(fees, 0)}
            </li>
            <li>
              <strong>Stamp Duty</strong>
              <br />
              {formatCurrency(stampDuty, 0)}
            </li>
            <li>
              <strong>Purchase Price</strong>
              <br />
              {formatCurrency(purchasePrice, 0)}
            </li>
          </ul>

          <div className={styles.chart_half_1_chart}>
            <ul className={styles.chart_half_1_chart_bars}>
              <li style={{ height: `${(repairProvisions / totalIncludingCosts) * 100}%` }}></li>
              <li style={{ height: `${(fees / totalIncludingCosts) * 100}%` }}></li>
              <li style={{ height: `${(stampDuty / totalIncludingCosts) * 100}%` }}></li>
              <li style={{ height: `${(purchasePrice / totalIncludingCosts) * 100}%` }}></li>
            </ul>
            <div className={styles.chart_half_1_chart_illustration}></div>
          </div>
        </li>

        <li className={styles.chart_half_2}>
          <ul className={styles.chart_half_2_legend}>
            <li>
              <strong>Tenant&apos;s Equity Loan</strong>
              <br />
              {formatCurrency(tenantEquityLoan, 0)}
            </li>
            <li>
              <strong>Standard Equity Loan</strong>
              <br />
              {formatCurrency(standardEquityLoan, 0)}
            </li>
            <li>
              <strong>First Charge Mortgage</strong>
              <br />
              {formatCurrency(firstChargeMortgage, 0)}
            </li>
          </ul>

          <div className={styles.chart_half_2_chart}>
            <ul className={styles.chart_half_2_chart_bars}>
              <li style={{ height: `${(tenantEquityLoan / totalIncludingCosts) * 100}%` }}></li>
              <li style={{ height: `${(standardEquityLoan / totalIncludingCosts) * 100}%` }}></li>
              <li style={{ height: `${(firstChargeMortgage / totalIncludingCosts) * 100}%` }}></li>
            </ul>
            <div className={styles.chart_half_2_chart_illustration}></div>
          </div>
        </li>
      </ul>
    )
  }
}
